{
  "nl": {
    "todo_v2": {
      "actions": {
        "confirm": "Markeer als klaar",
        "create": "Taak",
        "reopen": "Heropenen",
        "update": "Taak bewerken"
      },
      "assignee_types": {
        "customer": "Klant",
        "employee": "Medewerker",
        "partner": "Partner"
      },
      "attributes": {
        "assignees": "Toegewezen aan",
        "created_at": "Aangemaakt",
        "due_date": "Vervaldatum",
        "project": "Project",
        "status": "Status",
        "todo_group": "Taak",
        "unit": "Eenheid"
      },
      "labels": {
        "add_assignee": "Toegewezen aan toevoegen…",
        "add_customers": "Klanten toevoegen",
        "completed": "Voltooid",
        "confirm_message": "Weet je zeker dat je deze taak als voltooid wilt markeren?",
        "customers": "Klanten",
        "group_already_added": "Deze taak is al toegevoegd aan deze eenheid.",
        "my_todos": "Mijn taken",
        "no_assignees": "Nog geen toegewezen aan.",
        "no_todos": "Nog geen taken.",
        "no_todos_group": "Nog geen taken in deze groep.",
        "no_todos_unit": "Nog geen taken voor deze eenheid.",
        "publish_all": "Alles publiceren",
        "publish_customers": "Publiceren voor de klanten van elke eenheid",
        "published": "Gepubliceerd",
        "required": "Dit veld is verplicht",
        "select_group": "Selecteer een taak",
        "upload_hint": "Upload het gevraagde document of de gevraagde documenten om deze taak te voltooien.",
        "uploaded_documents": "Geüploade documenten"
      },
      "statuses": {
        "completed": "Voltooid",
        "draft": "Concept",
        "pending": "In behandeling"
      },
      "toasts": {
        "completed": "Taak voltooid",
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "uncompleted": "Taak heropend",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
